import type { ExpressionTopic } from "../shared/refinement";
import type { NarrativeLayer } from "./types";

export const SCREEN_TITLES = [
  "碑中有风",
  "三重墨印",
  "新恩与旧约",
  "史书记",
  "先走，还是先报恩",
  "封金挂印",
  "风雨成字",
  "叶片组字",
  "藏诗揭晓",
  "不必成为关羽",
  "写下一句",
  "AI 借竹明志",
  "竹画工坊",
  "我的风雨竹",
  "碑外一页",
] as const;

export const LAYER_CONTENT: Record<
  NarrativeLayer,
  { label: string; title: string; text: string }
> = {
  history: {
    label: "史书记",
    title: "史书的骨架",
    text: "曹操厚待关羽；关羽念刘备旧恩，希望先立功报答曹操再离开；之后封存赏赐，拜书告辞。",
  },
  legend: {
    label: "传说记",
    title: "后人的想象",
    text: "土山约三事、风雨竹和竹叶秘密传志属于后世传说与文学演绎，不作为已经证实的正史。",
  },
  game: {
    label: "游戏演绎",
    title: "碑中的这一程",
    text: "玩家进入碑中、与碑灵墨竹对话、移动竹叶组字并创作个人风雨竹，都是本作的互动演绎。",
  },
};

export const FIRST_CHOICES = ["旧约不能改", "新恩不能忘", "先活下来再决定", "自己输入一句"];

export const FIRST_REFLECTIONS: Record<string, { mark: string; text: string }> = {
  旧约不能改: { mark: "信", text: "你更在意承诺不能因处境改变。这片叶，记作“信”。" },
  新恩不能忘: { mark: "恩", text: "你没有让旧约抹去眼前的厚待。这片叶，记作“恩”。" },
  先活下来再决定: { mark: "生", text: "你先为选择保留余地。这片叶，只记录此刻的“生”。" },
};

export const TOPICS: Array<{ value: ExpressionTopic; label: string; hint: string }> = [
  { value: "守住", label: "我想守住", hint: "一份承诺、一条原则，或一件不愿放下的事" },
  { value: "感谢", label: "我想感谢", hint: "一份得到过、却还没有好好回应的善意" },
  { value: "告别", label: "我想告别", hint: "一段关系、一个地方，或过去的自己" },
  { value: "出发", label: "我想出发", hint: "一条正在犹豫、却已经看见的路" },
  { value: "不便直说", label: "我有一句不便直说的话", hint: "不必交代人物与细节，只留下它的分量" },
];

export const POEM = ["不谢东君意", "丹青独立名", "莫嫌孤叶淡", "终久不凋零"];

export const SOURCES = [
  {
    title: "《三国志·蜀书·关羽传》",
    text: "用于关羽受曹操厚待、念刘备旧恩、希望先报曹恩再离开、封存赏赐并告辞等主线骨架。",
  },
  {
    title: "西安碑林《关帝诗竹》藏品说明",
    text: "现存碑刻为清康熙五十五年韩宰临摹立石；产品以审慎口径说明作品的长期临摹和传播。",
    url: "https://beilin-museum.com/index.php?a=index&aid=2639&c=View&m=home",
  },
  {
    title: "产品批准的传说口径",
    text: "风雨竹、秘密传志与竹叶藏诗作为“传说记”呈现，不称为已经证实的关羽亲笔。",
  },
];
